import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/** Fetches every imported document of a dossier: `fetchImportedDocuments` walks the server pages itself. */
class FetchImportedDocuments {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
	) {
		Object.freeze(this);
	}
}

export default FetchImportedDocuments;
